import React from 'react';
import { Col, Row, Typography } from 'antd';

const { Title, Text } = Typography;

interface BusinessOverviewSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const BusinessOverviewSection: React.FC<BusinessOverviewSectionProps> = ({
  title,
  subtitle,
  children,
}) => (
  <Col span={24}>
    <div style={{ marginBottom: subtitle ? 4 : 16, marginTop: 8 }}>
      <Title level={5} style={{ margin: 0 }}>
        {title}
      </Title>
      {subtitle && (
        <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 13 }}>
          {subtitle}
        </Text>
      )}
    </div>
    <Row gutter={[16, 16]} align="stretch" style={{ marginTop: subtitle ? 12 : 0 }}>
      {children}
    </Row>
  </Col>
);

export default BusinessOverviewSection;
